import * as React from 'react';
export const replitSvg = React.forwardRef(function replitSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 7.672c0-.647.529-1.171 1.18-1.171h5.512c.652 0 1.181.524 1.181 1.171v5.079H9.181A1.178 1.178 0 0 1 8 11.579V7.672Z',
      fill: '#FD5402',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.873 12.75h6.908A1.22 1.22 0 0 1 24 13.97v4.062a1.22 1.22 0 0 1-1.219 1.219h-6.908v-6.5ZM8 20.422c0-.647.529-1.171 1.18-1.171h6.693v5.078c0 .647-.529 1.172-1.18 1.172H9.18A1.177 1.177 0 0 1 8 24.329v-3.907Z',
      fill: '#FD5402',
    }),
  );
});
replitSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var replit = {
  category: 'brand',
  colorable: false,
  name: 'replit',
  svg: replitSvg,
};
